import api from 'services/api';

/**
 * DELETE `/python_libraries/:id`. Resolves on success; throws on HTTP error (404 when the library
 * is already gone) so the caller can surface the message.
 *
 * The 200 body is a `{ deleted: true, python_library_id }` acknowledgement echoing the id the
 * caller already holds — no load-bearing data, so there is nothing to validate or return.
 */
export const deletePythonLibrary = async (id: number): Promise<void> => {
  await api.delete(`/python_libraries/${id}`);
};
